import { Accents, Component, Knobs, Story } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  accent: { default: 'viridiangreen', editor: 'dropdown', editorOptions: Accents },
  allowDataTypeEditing: { default: false, editor: 'checkbox' },
  allowCaptionEditing: { default: false, editor: 'checkbox' },
};

const Playground: Story = {
  title: 'Playground',
  description: 'A column picker',
  coreComponent_v3: {
    html: `<tag3-column-picker{{...knobs}}></tag3-column-picker>
<tag3-simple-button>Open</tag3-simple-button>`,
    js: `var columns = [
  {name: "id", caption: "ID", alwaysHidden: true},
  {name: "name", caption: "Name", alwaysVisible: true},
  {name: "category", caption: "Category", visible: true },
  {name: "level", caption: "Level"},
  {name: "address", caption: "Address"},
  {name: "postcode", caption: "Postcode", visible: true},
  {name: "phoneNumber", caption: "Phone Number", dataType: "phonenumber"},
  {name: "mobile", caption: "Mobile", dataType: "phonenumber"},
  {name: "amount", caption: "Amount"},
  {name: "email", caption: "Email", dataType: "email", visible: true},
  {name: "jobTitle", caption: "Job Title"},
  {name: "gender", caption: "Gender"},
  {name: "maritalStatus", caption: "Marital Status"},
  {name: "niNumber", caption: "National Insurance Number"},
  {name: "dob", caption: "DateOfBirth", dataType: "date"},
  {name: "ethnicity", caption: "Ethnicity"},
  {name: "nationality", caption: "Nationality"}
];
var picker = document.querySelector('tag3-column-picker');
picker.columns = columns;
picker.getResetColumns = function () {
  return columns;
}
var openButton = document.querySelector('tag3-simple-button');
openButton.addEventListener("buttonClick", function () {
  picker.columns = columns;
  picker.open = true;
});
`,
    knobs: PlaygroundStoryKnobs,
  },
  reactWrapper_v3: {
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);
  const columns = [
    {name: "id", caption: "ID", alwaysHidden: true},
    {name: "name", caption: "Name", alwaysVisible: true},
    {name: "category", caption: "Category", visible: true },
    {name: "level", caption: "Level"},
    {name: "address", caption: "Address"},
    {name: "postcode", caption: "Postcode", visible: true},
    {name: "phoneNumber", caption: "Phone Number", dataType: "phonenumber"},
    {name: "mobile", caption: "Mobile", dataType: "phonenumber"},
    {name: "amount", caption: "Amount"},
    {name: "email", caption: "Email", dataType: "email", visible: true},
    {name: "jobTitle", caption: "Job Title"},
    {name: "gender", caption: "Gender"},
    {name: "maritalStatus", caption: "Marital Status"},
    {name: "niNumber", caption: "National Insurance Number"},
    {name: "dob", caption: "DateOfBirth", dataType: "date"},
    {name: "ethnicity", caption: "Ethnicity"},
    {name: "nationality", caption: "Nationality"}
  ];
  return (
    <>
      <Tag3ColumnPicker open={open}{{...knobs}}
        columns={columns}
        onColumnPickerClosed={() => setOpen(false)}
        getResetColumns={() => columns}
      />
      <Tag3SimpleButton onButtonClick={() => setOpen(true)}>Open</Tag3SimpleButton>
    </>
  )
}`,
    knobs: PlaygroundStoryKnobs,
    jsx: `<Example />`,
  },
};

export const TagColumnPickerDocs: Component = {
  type: 'component',
  name: 'column-picker',
  description: 'Renders a modal to choose columns',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'open',
      description: 'Whether the column picker is open or not',
      type: 'boolean',
    },
    {
      name: 'columns',
      description: 'The columns to configure',
      type:
        'Array<{name: string; caption: string; visible: boolean; alwaysVisible?: boolean; alwaysHidden?: boolean; defaultHidden?: boolean; dataType?: string;}>',
    },
    {
      name: 'accent',
      description: 'The accent colour within the column picker dialog',
      type: 'Accent',
    },
    {
      name: 'allowDataTypeEditing',
      description: 'Whether the column picker allows the column data types to be changed',
      type: 'boolean',
    },
    {
      name: 'allowCaptionEditing',
      description: 'Whether the column picker allows the column captions to be changed',
      type: 'boolean',
    },
    {
      name: 'getResetColumns',
      description:
        'Raised when the Reset button of the column picker is pressed. Should return the reset columns',
      type: '() => Array<{ name: string; caption: string; visible: boolean; dataType: string}>',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'columnPickerColumnsChanged',
      description: 'Raised when the OK button of the column picker is pressed',
      parameters: [
        {
          name: 'columns',
          description: 'The updated set of columns',
          type: 'Array<{ name: string; caption: string; visible: boolean; dataType: string}>',
        },
      ],
    },
    {
      name: 'columnPickerClosed',
      description: 'Raised when the column picker is closed',
      parameters: [],
    },
  ],
  methods: [],
  stories: [Playground],
  childComponents: [],
};
